import { connect } from "react-redux";
import { goBack, push } from "react-router-redux";

import Notifications from "../components/Notifications/Notifications";
import * as actions from "../redux/actions/Notification";
import { getUser } from "../redux/actions/AccountSetting";

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  isLoadingNotifications: state.notification.isLoadingNotifications,
  notifications: state.notification.notifications.toIndexedSeq().toArray(),
  pageInfo: state.notification.pageInfo,
});

const mapDispatchToProps = (dispatch) => ({
  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  getUserInfo() {
    dispatch(getUser(true));
  },

  getNotifications(data) {
    dispatch(actions.getNotifications(data));
  },

  postNotificationsMark(id, data) {
    dispatch(actions.postNotificationsMark(id, data));
  },

  toggleSystemNotificationDialog(item) {
    dispatch(actions.toggleSystemNotificationDialog(item));
  },

  toggleRecommendRelocationPersonnelNotificationDialog(item) {
    dispatch(actions.toggleRecommendRelocationPersonnelNotificationDialog(item));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/containers/Notifications.js